import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { useColorContrast } from 'utils/hooks';
import { ReactComponent as LowContrastIcon } from 'assets/img/icons/optional.svg';
import { ReactComponent as GoodContrastIcon } from 'assets/img/icons/check-green.svg';

export default function ColorContrast({
  label = 'Color Contrast =',
  color = '#ffffff',
  backgroundColor = '#ffffff',
  delay = 100,
  threshold = 3,
  className = ''
}) {
  const contrastRatio = useColorContrast({
    foregroundColor: color,
    backgroundColor,
    delay
  });

  return (
    <div className={cn(styles.container, className)}>
      <If test={contrastRatio > threshold} otherwise={<LowContrastIcon />}>
        <GoodContrastIcon />
      </If>
      {label}
      <strong>{contrastRatio}</strong>
    </div>
  );
}
